import React from "react";
import { CardContainer } from "./CardComponent.styled";
import { ReactComponent as SurveyIcon } from "../../../assets/svg/survey-gradient-icon-2.0.svg";
import { ReactComponent as CalendarIcon } from "../../../assets/svg/calendar-gradient-icon-2.0.svg";
import { ReactComponent as CoachesIcon } from "../../../assets/svg/coach-gradient-icon-2.0.svg";
import { ReactComponent as EngagementIcon } from "../../../assets/svg/engagement-gradient-icon-2.0.svg";
import { ReactComponent as GamificationIcon } from "../../../assets/svg/gamification-gradient-icon-2.0.svg";
import { ReactComponent as KnowledgeIcon } from "../../../assets/svg/knowledge-gradient-icon-2.0.svg";
import { ReactComponent as ReportingIcon } from "../../../assets/svg/reporting-gradient-icon-2.0.svg";
import PropTypes from "prop-types";

const CardComponent = ({ title, description, video, id, handleShowVideo, onClick }) => {
  const handleKeyDown = onClick
    ? (e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); onClick(e); } }
    : undefined;

  const getIcon = (id) => {
    switch (id) {
      case "Survey":
        return <SurveyIcon />;
      case "Calendar":
        return <CalendarIcon />;
      case "Coaches":
        return <CoachesIcon />;
      case "Engagement":
        return <EngagementIcon />;
      case "Gamification":
        return <GamificationIcon />;
      case "KnowledgeManagement":
        return <KnowledgeIcon />;
      case "Reporting":
        return <ReportingIcon />;
      default:
        return <SurveyIcon />;
    }
  };

  return (
    <CardContainer
      onClick={onClick}
      clickable={!!onClick}
      role={onClick ? "button" : undefined}
      tabIndex={onClick ? 0 : undefined}
      onKeyDown={handleKeyDown}
    >
      {getIcon(id)}
      <label className="card-title">{title}</label>
      {description && <p className="card-desc">{description}</p>}
      {handleShowVideo && video && (
        <button
          type="button"
          className="card-link"
          onClick={(e) => { e.stopPropagation(); handleShowVideo(video); }}
        >
          See demo
        </button>
      )}
    </CardContainer>
  );
};

CardComponent.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  video: PropTypes.string,
  id: PropTypes.string,
  handleShowVideo: PropTypes.func,
  onClick: PropTypes.func,
};

export default CardComponent;
